import { useMutation } from '@tanstack/react-query';
import {
  deleteFile,
  downloadFile,
  uploadFile,
} from '../requests/s3';

const KEY = 's3';

const useUpload = () => useMutation({
  mutationKey: [KEY, 'upload'],
  mutationFn: (data) => uploadFile(data),
});

const useDelete = () => useMutation({
  mutationKey: [KEY, 'delete'],
  mutationFn: (data) => deleteFile(data),
});

const useDownload = () => useMutation({
  mutationKey: [KEY, 'download'],
  mutationFn: (data) => downloadFile(data),
});

const agentMutations = {
  useUpload,
  useDelete,
  useDownload,
};

export default agentMutations;
